import React from 'react'
import { classNames } from '../utils'

interface ValuePropProps {
  title?: string
}

export const ValuePropBullet = ({ title }: ValuePropProps) => {
  return (
    <h2
      className={classNames(
        'header-highlight-small relative mb-7 pl-m text-xl leading-snug',
        'text-default-50'
      )}
    >
      {title}
    </h2>
  )
}
